module.exports = __webpack_public_path__ + "img/zw3.0c3fd959.webp";